export default "__VITE_ASSET__DjKeuoYg__"